import {CurrentUser, CurrentUserAccessToken} from "../components/Auth/Services/CurrentUser";

export const configRequest = () => {
    return {
        headers: {
            Username: CurrentUser()?.getUsername(),
            AccessToken: CurrentUserAccessToken()
        }
    }
}